module.exports = "https://cdn.thelire.com/ins/resource/lh_app_vip_medal.20c99e58b68a7f5df05b4c3896b8a1f7.png";